<template>
  <div class="mensaje">
    <h2 class="mensaje__titulo titulo-h2">Validar Email</h2>
    <div class="mensaje__mensaje">
      <span class="mensaje__texto" v-html="contenido"></span>
    </div>
    <i class="mensaje__icono" :class="'mensaje__icono-email'" />       
  </div>    
</template>

<script>
export default {
  computed:{
    contenido(){
      return 'Te hemos enviado un correo a la dirección de email que indicaste. Ingresa a tu cuenta de correo y haz clic en el botón <b>Confirmar Email</b>. Una vez se valide tu correo podrás continuar con el registro.'
    }
  }
}
</script>